import { Marker } from "react-leaflet";
import L from "leaflet";
import { FenceGate, GateSizeEnum } from "models/fenceGate";
import { FenceSegment } from "models/fenceSegment";
import doubleGateIcon from "icons/double_gate.svg";
import singleGateIcon from "icons/single_gate.svg";

type Props = {
  fences: FenceSegment[];
};

export const GateMarkers = function ({ fences }: Props) {
  const gates: Array<FenceGate> = [];
  fences.forEach((f) => gates.push(...f.gates));

  return (
    <>
      {gates.map((g) => {
        const iconUrl = g.size === GateSizeEnum.DOUBLE ? doubleGateIcon : singleGateIcon;
        const icon = L.icon({ iconUrl, iconSize: [18, 18], iconAnchor: [9, 9] });
        return <Marker key={g.id} position={[g.coords.lat, g.coords.lon]} icon={icon} />;
      })}
    </>
  );
};
